// extracted by mini-css-extract-plugin
module.exports = {"container":"login-form-footer_container__yVNg1","text":"login-form-footer_text__Zrp36","logo":"login-form-footer_logo__Br5gU"};